"use client";

import * as React from "react";
import { BookOpen, MonitorPlay, Users, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const resources = [{
  title: "Tight Access Specialist",
  description: "Retractable tracks (990mm to 1300mm) allow for easy entry through standard side gates and narrow pathways.",
  icon: Briefcase
}, {
  title: "Full Bucket Kit",
  description: "Equipped with 300mm, 450mm GP, and 900mm mud buckets to handle any digging or levelling task.",
  icon: BookOpen
}, {
  title: "Precision Hydraulics",
  description: "Advanced hydraulic systems provide smooth operation for delicate work near existing structures and services.",
  icon: MonitorPlay,
  link: "/CoreServicesPage"
}, {
  title: "Plant Trailer Included",
  description: "Available on a high-quality plant trailer for easy self-towing or convenient delivery to your worksite.",
  icon: Users,
  link: "https://set-starfish.10web.cloud/contact/"
}];
export default function StudentResources() {
  return <section data-section-id="226834" id="17t-excavator-with-buckets" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">

          <div className="lg:col-span-7">
            <div className="mb-10">
              <h2 className="font-default text-3xl font-bold tracking-wider text-foreground sm:text-4xl uppercase">
                Kubota 1.7t Mini Excavator Hire & Rental
              </h2>

              <p className="font-default mt-4 text-lg leading-relaxed text-muted-foreground max-w-2xl">
                High-performance machinery for your next earthmoving project.
                Compact, powerful, and ready to work in confined residential or
                commercial sites with maximum efficiency.
              </p>

              <div className="mt-8">
                <Link to="https://set-starfish.10web.cloud/contact/" className="inline-flex items-center justify-center bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-4 font-bold uppercase transition-colors w-fit group">
                  Enquire Now
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {resources.map((item, i) => {
              const Icon = item.icon;
              return <div data-index={i} key={i}>
                    <Card className="group relative h-full overflow-hidden border-border/50 bg-card shadow-sm transition-all duration-300 hover:-translate-y-2.5 hover:shadow-xl">
                      <CardContent className="p-6 flex flex-col h-full">
                        <div className="mb-5 inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-primary/10 relative overflow-hidden">
                          <div className="absolute inset-0 bg-primary/5 mix-blend-multiply" />
                          <Icon className="relative z-10 h-7 w-7 text-primary" strokeWidth={2} />
                        </div>

                        <h3 className="font-default text-xl font-semibold text-foreground mb-3">
                          {item.title}
                        </h3>

                        <p className="font-default text-lg leading-relaxed text-muted-foreground flex-grow">
                          {item.description}
                        </p>
                      </CardContent>
                    </Card>
                  </div>;
            })}
            </div>
          </div>

          <div className="lg:col-span-5 relative mt-8 lg:mt-0">
            <div className="relative w-full lg:w-[115%] lg:translate-x-4 xl:translate-x-8">

              <div className="absolute -bottom-6 -right-6 top-6 left-6 -z-10 rounded-3xl bg-primary/5" />
              <div className="absolute -top-6 -left-6 bottom-6 right-6 -z-10 rounded-3xl border border-primary/10" />

              <AspectRatio ratio={3 / 4} className="bg-muted rounded-2xl shadow-2xl overflow-hidden">
                <img src="https://bottomupprojects.com.au/wp-content/uploads/2026/04/excavator.png" alt="Kubota 1.7t mini excavator with full bucket set on a job site" className="h-full w-full object-contain transition-transform duration-700 hover:scale-95" loading="lazy" />
              </AspectRatio>

            </div>
          </div>

        </div>
      </div>
    </section>;
}